import * as Yup from 'yup';

export const useSignupSchema = (t) =>
    Yup.object().shape({
        firstName: Yup.string()
            .trim()
            .min(3, t('jobSeekerRegistration:namesMinValidation'))
            .max(25, t('jobSeekerRegistration:namesMaxValidation'))
            .matches(/^[A-ZƏÜÖİĞÇŞQI][a-zəüöiğçjşı]{2,25}$/, t('jobSeekerRegistration:namesValidation'))
            .required(t('jobSeekerRegistration:firstNameRequired')),

        lastName: Yup.string()
            .trim()
            .min(3, t('jobSeekerRegistration:namesMinValidation'))
            .max(25, t('jobSeekerRegistration:namesMaxValidation'))
            .matches(/^[A-ZƏÜÖİĞÇŞQI][a-zəüöiğçjşı]{2,25}$/, t('jobSeekerRegistration:namesValidation'))
            .required(t('jobSeekerRegistration:lastNameRequired')),
        password: Yup.string()
            .trim()
            .max(25, t('jobSeekerRegistration:passwordLength'))
            .notOneOf([Yup.ref('email')], t('jobSeekerRegistration:passwordAndEmailEqual'))
            .required(t('jobSeekerRegistration:passwordRequired')),
        email: Yup.string()
            .email(t('jobSeekerRegistration:emailInvalid'))
            .required(t('jobSeekerRegistration:emailRequired')),
    });
